import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import styles from "./Badge.module.scss";

export default function Badge({ 
  color = "gray",
  children,
  className 
}) {
  const badgeClasses = classNames(
    styles.badge,
    styles[color],
    className
  );
  return <span className={badgeClasses}>{children}</span>;
}


Badge.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  className: PropTypes.string,
  children: PropTypes.node
};
